import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { PublicClientApplication } from "@azure/msal-browser";
import { MsalProvider } from "@azure/msal-react";
import { Toaster } from "sonner";

// Configuration
import { msalConfig } from "./authConfig";
import { setMsalInstance } from "./API/apiClient";

// Routes
import AppRoutes from "./Routes";

// Global Styles (order matters - base styles first, then libraries)
import "./index.css";
import "primereact/resources/themes/lara-light-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";

// Initialize MSAL instance
const msalInstance = new PublicClientApplication(msalConfig);

async function initializeApp() {
  try {
    // 1. Initialize MSAL core library
    await msalInstance.initialize();

    // // 2. CRITICAL: Handle redirect response if returning from Azure AD login
    // const redirectResponse = await msalInstance.handleRedirectPromise();
    // if (redirectResponse && redirectResponse.account) {
    //   msalInstance.setActiveAccount(redirectResponse.account);
    // }

    // 3. If no active account is set yet, check if accounts exist in cache (localStorage)
    const currentAccounts = msalInstance.getAllAccounts();
    if (currentAccounts.length > 0 && !msalInstance.getActiveAccount()) {
      msalInstance.setActiveAccount(currentAccounts[0]);
    } 
    // else if (!redirectResponse) {
    //   // 4. IF NO ACCOUNTS EXIST AND NOT RETURNING FROM REDIRECT: Force Login!
    //   setMsalInstance(msalInstance);
      
    //   // This immediately redirects the browser to Microsoft login
    //   await msalInstance.loginRedirect({
    //     scopes: ["User.Read"], // Add your required scopes here
    //   });
    //   return; // Stop further execution while the browser redirects
    // }

    // Pass instance to your API client
    setMsalInstance(msalInstance);

    // 4. Render the app only after authentication state is fully evaluated
    const root = createRoot(document.getElementById("root"));
    root.render(
      <StrictMode>
        <MsalProvider instance={msalInstance}>
          <Toaster
            richColors
            position="top-right"
            expand={false}
            closeButton
            duration={4000}
          />
          <AppRoutes />
        </MsalProvider>
      </StrictMode>
    );
  } catch (error) {
    console.error("MSAL Initialization or Redirect handling failed:", error);
  }
}

initializeApp();

// Initialize MSAL before rendering
// msalInstance.initialize().then(() => {
//   setMsalInstance(msalInstance);
//   const root = createRoot(document.getElementById("root"));

//   root.render(
//     <StrictMode>
//       <MsalProvider instance={msalInstance}>
//         <Toaster
//           richColors
//           position="top-right"
//           expand={false}
//           closeButton
//           duration={4000}
//         />
//         <AppRoutes />
//       </MsalProvider>
//     </StrictMode>
//   );
// });
